export default {
    FS_RESPIN: 'fs_respin',

}